import { createTheme } from '@mui/material/styles';

// Gestion & Holdings CFFA brand theme
export const brand = {
    brown950: '#20110a',
    brown900: '#2c170d',
    brown800: '#432312',
    brown600: '#6b3a1f',
    orange600: '#e2571f',
    orange500: '#ef6f2c',
    orange400: '#f68f4f',
    cream50: '#fffaf3',
    cream100: '#fdf1de',
    cream200: '#f7e4c6',
    gold500: '#cf9a3b',
    chili600: '#b5402a',
    green700: '#4f6b42',
    ink: '#20140c',
};

const theme = createTheme({
    palette: {
        primary: {
            main: brand.orange600,
            dark: brand.brown900,
            light: brand.orange400,
            contrastText: brand.cream50,
        },
        secondary: {
            main: brand.brown800,
            dark: brand.brown950,
            light: brand.brown600,
            contrastText: brand.cream50,
        },
        background: {
            default: brand.cream50,
            paper: '#ffffff',
        },
        text: {
            primary: brand.ink,
            secondary: brand.brown600,
        },
        success: { main: brand.green700 },
        warning: { main: brand.gold500 },
        error: { main: brand.chili600 },
    },
    typography: {
        fontFamily: '"Work Sans", "Helvetica", "Arial", sans-serif',
        h1: { fontFamily: '"Fraunces", serif', fontWeight: 700, letterSpacing: '-0.01em' },
        h2: { fontFamily: '"Fraunces", serif', fontWeight: 700, letterSpacing: '-0.01em' },
        h3: { fontFamily: '"Fraunces", serif', fontWeight: 600, letterSpacing: '-0.01em' },
        h4: { fontFamily: '"Fraunces", serif', fontWeight: 600 },
        h5: { fontFamily: '"Fraunces", serif', fontWeight: 600 },
        h6: { fontFamily: '"Fraunces", serif', fontWeight: 600 },
        button: { fontWeight: 700, textTransform: 'none' },
    },
    shape: {
        borderRadius: 10,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    '&:hover': { backgroundColor: brand.brown900 },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: { borderRadius: 14 },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: brand.brown950,
                    color: brand.cream100,
                },
            },
        },
    },
});

export default theme;
